export default __webpack_public_path__ + "static/media/pointsN.00cd44c5.svg";